import uuid from 'uuid/v4';
import { smb_fetch, getSsoCgiUrl } from '@/api/operator/fetch';
import globalStore from '@/stores';
import { SESSION_SCENE } from '../constants';

/**
 * 创建会话ID
 */
export const createSessionId = async (data: any) => {
  try {
    const url = getSsoCgiUrl('eden/chat', 'create_session_id');
    const res: any = await smb_fetch(url, {
      method: 'POST',
      contentType: 'application/json',
      headers: {
        'x-platform-type': 2, // 1：工作台  2.服务商
        'x-account-id': globalStore.account.bm_id || globalStore.account.agency_uid,
      },
      data: {
        session_scene: SESSION_SCENE.DEFAULT,
        ...data,
      },
    }, false, false);
    const sessionId = res?.data?.session_id || uuid();
    return sessionId;
  } catch (error) {
    return uuid();
  }
};

